function initRecepies() {
  const slider = document.querySelector('.recepies__slider');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: slider.querySelector('.recepies__slider .swiper-navigation__btn--next'),
      prevEl: slider.querySelector('.recepies__slider .swiper-navigation__btn--prev'),
    },

    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  });
}

export { initRecepies };